export const billingKeys = {
  all: (orgId: string) => ["billing", orgId] as const,
  detail: (orgId: string) => ["billing", orgId, "subscription"] as const,
};
